import { createSortOption } from "@nosto/preact"
export const sizes = [24, 48, 72]

export const sortOptions = [
    createSortOption("score", "Featured", { field: "score", order: "desc" }),
    createSortOption("price", "Price: Lowest - Highest", { field: "price", order: "asc" }),
    createSortOption("-price", "Price: Highest - Lowest", { field: "price", order: "desc" }),
    createSortOption("newest", "Newest First", { field: "datePublished", order: "asc" }),
    createSortOption("oldest", "Oldest First", { field: "datePublished", order: "desc" }),
    createSortOption("name", "A - Z", { field: "name", order: "asc" }),
    // createSortOption("-name", "Z - A", { field: "name", order: "desc" }),
    // createSortOption("rating", "Top Rated: Lowest - Highest", { field: "ratingValue", order: "asc" }),
    // createSortOption("-rating", "Top Rated: Highest - Lowest", { field: "ratingValue", order: "desc" }),
]

export const defaultConfig = {
    sort: sortOptions[0],
    serpSize: sizes[0],
    autocompleteProductsSize: 4,
    autocompleteKeywordsSize: 5,
    historySize: 5,
    currency: "USD"
}

export const topSearches = [
    {
        text: "Boots",
        url: "/collections/womens-boots"
    },
    {
        text: "Booties",
        url: "/collections/womens-booties"
    },
    {
        text: "Sneakers",
        url: "/collections/womens-sneakers"
    },
    {
        text: "Campus 14L",
        url: "/products/campus-14l"
    },
    {
        text: "Handbags",
        url: "/collections/handbags"
    },
]

export const expandedFacets = [
    // "Product Type",
    // "Size",
    // "Style",
    // "Color",
]

// match facet.name (case-sensitive)
export const boxedFacets = {
    "Size": { desktopCols: 5, mobileCols: 4 },
    "Style": { desktopCols: 3, mobileCols: 3 },
    "Icons": { desktopCols: 3, mobileCols: 3 },
    "Heel Height": { desktopCols: 3, mobileCols: 3 },
    "Shaft Height": { desktopCols: 3, mobileCols: 3 },
}

export const filtersOrder = {
    "Heel Height" : [ 
        "Flat Heel", 
        "Low Heel",
        "Mid Heel",
        "High Heel"
    ],
    "Shaft Height" : [
        "Low Shaft",
        "Medium Shaft",
        "High Shaft",
        "Short Shaft",
        "Tall Shaft"
    ]
}

export const uniqueColorSwatches = {
    "ash": "ash",
    // "ash-waxed-suede": "ASH-WAXED-SUEDE",
    "ash-waxed-suede": "ash-waxed-suede",
    "neutral": false,
    "cafe": false,
    "light-grey": false,
    "light-rose": false,
}

export const colorFacet = {
    "Beige": "#E7C4A4",
    "Black": "#000000",
    "Blue": "#000080",
    "Brown": "#7B3F2A",
    "Cognac": "#9D5A18",
    "Gold": "#BBA53D",
    "Gray": "#808080",
    "Green": "#095B03",
    "Ivory": "#FDF2E8",
    "Mustard": "#e2b700",
    "Off-White": "#F7F1F1",
    "Pink": "#F9CDD7",
    "Purple": "#551b8c",
    "Red": "#E12828",
    "Silver": "#C0C0C0",
    "Tan": "#D2915C",
    "Taupe": "#B29784",
    "White": "#F5F5F5",
    "Yellow": "#E2B700",
}

export const GQL_KEY = "HIAU4tKkB9Whi1DeGwUZhQBFZJtTSSVAisV2RArPvjTlgelOck2y6QGtuhUC8LXh";